import ctl from '@netlify/classnames-template-literals';

export const titleStyle = ctl(`
  text-anti-flash-white 
  font-bold 
  text-[36px]
`);
